import { cn } from "~/lib/utils";
import bucket from "./bucket";
import type { IconProps, IconColor } from "~/types/icon";

const colors: Record<IconColor, string> = {
  green: "bg-green-200",
  blue: "bg-blue-200",
  cyan: "bg-cyan-100",
  sky: "bg-sky-300",
  purple: "bg-purple-400",
  yellow: "bg-yellow-200",
  rose: "bg-rose-500",
}

export default function Icon({ icon, color }: IconProps) {
  return (
    <div
      className={cn("w-6 h-6 inline-block", colors[color ?? "purple"])}
      style={{
        maskImage: `url(${bucket[icon] ?? ""})`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskImage: `url(${bucket[icon] ?? ""})`,
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
